import React from 'react'
import { ButtonDep as Button } from '..'
import { Container } from '@kogk/common'
import { Fade } from 'react-reveal'

export type StatisticType = { statisticName: string; statisticValue: string }

const StatisticsBanner: React.FC<{
  category: string
  title: string
  description: string
  link?: {
    text: string
    url: string
  }
  statistics: StatisticType[]
  onRenderLink?: () => void
}> = ({ category, title, description, link, statistics, onRenderLink }) => {
  return (
    <div className='page-slice-spacer__smaller stat-banner mb-0'>
      <Container>
        <Fade left distance='25px'>
          <div className='stat-banner__inner'>
            <div className='d-flex align-items-center justify-content-between'>
              <div>
                <span className='stat-banner__inner--category'>{category}</span>
                <h2 className='stat-banner__inner--title'>{title}</h2>
              </div>
              {onRenderLink ? (
                onRenderLink()
              ) : (
                <a href={link?.url ?? '/'}>
                  <Button
                    className='d-none d-lg-flex align-items-end'
                    type='secondary'
                    icon='arrowRight'
                    label={link?.text ?? 'TEXT'}
                  />
                </a>
              )}
            </div>
            <p className='stat-banner__inner--description'>{description}</p>
            <div className='d-flex flex-column flex-lg-row justify-content-start flex-wrap px-0'>
              {statistics.map((s, i) => (
                <div className='d-flex flex-column stat-banner__data' key={i}>
                  <h4 className='stat-banner__data--name'>{s.statisticName}</h4>
                  <h2 className='stat-banner__data--value'>{s.statisticValue}</h2>
                </div>
              ))}
            </div>
          </div>
        </Fade>
      </Container>
    </div>
  )
}

export default StatisticsBanner
